// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.LoginRegister.Register.View'
,	[
	'c3_shoppingextensions_loginregister_register.tpl'
	,  'Profile.Model'
	//,	'NXTurn.ShoppingExtensions.LoginRegister.SS2Model'
	,	'Backbone'
	,   'Backbone.FormView'
	,   'Backbone.CompositeView'
	,    'Tracker'
	//,	'SC.Configuration'
    ,   'Session'	
    ,   'C3.ShoppingExtensions.LoginRegister.Register.Model'
    ,   'Utils'
    ,   'LiveOrder.Model'
    ,   'GlobalViews.Message.View'
    ,   'Loggers'
    ,   'GoogleTagManager'
    ,   'C3.ShoppingExtensions.LoginRegister.Register.Countries.View'
    ,   'C3.ShoppingExtensions.LoginRegister.Register.States.View'
    ]
, function (
	c3_shoppingextensions_loginregister_register_tpl
	,   ProfileModel
	//,	LoginRegisterSS2Model	
	,	Backbone
	,   BackboneFormView
	,   BackboneCompositeView
	,   Tracker
	//,   Configuration
	,   Session
	,   AccountRegisterModel
	,   Utils
	,   LiveOrderModel
	,   GlobalViewsMessageView
    ,   Loggers
    ,   GoogleTagManager
    ,   CountriesView
    ,   StatesView
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_loginregister_register_tpl

	, attributes: {
        id: 'register'
    }	

    ,  events: {
        'submit form': 'submitForm',
        'click [data-action="show-hidden-register-section"]':'showHiddenSection',
        'change [data-action="selectcountry"]': 'updateStates',
        'input input': 'checkRegisterFields',
        'change select': 'checkRegisterFields'
    }

    ,  bindings: {
        '[name="firstname"]': 'firstname',
        '[name="lastname"]': 'lastname',
        /*'[name="company"]': 'company',
        '[name="country"]': 'country',
        '[name="ima"]': 'ima',*/
        '[name="ima"]': 'ima',
        '[name="email"]': 'email',
        '[name="custentity_destination_country"]': 'custentity_destination_country',
        '[name="custentity_customer_state"]': 'custentity_customer_state',
        '[name="password"]': 'password',
        '[name="password2"]': 'password2'
    }

	,	initialize: function (options) {
    		this.options = options;
            this.application = options.application;
            this.parentView = options.parentView;
            //console.log(this.application)
            this.countries = this.application.configuration.get('siteSettings.countries', []);

            var profile = ProfileModel.getInstance()
            ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'

            if(is_logged_in)
            {
                var addressBook = profile.get('addressbook');

                var find_shippingAddr = _.findWhere(addressBook, {
                    defaultshipping: 'T'
                });

                if(find_shippingAddr)
                {
                    this.loggedUserCountry = find_shippingAddr.country
                    this.loggedUserState = find_shippingAddr.state
                }
            }

            this.model = options.model || new AccountRegisterModel();
            // on save we redirect the user out of the registration page
            // as we know there hasn't been an error
            this.model.on('save', _.bind(this.redirect, this));

            BackboneFormView.add(this);
			
		},


    childViews: {
            'Register.Countries.Dropdown': function() {
                //console.log(this.countries)
                if(this.loggedUserCountry)
                this.selectedCountry =  this.loggedUserCountry;

                return new CountriesView({
                    countries: this.countries,
                    selectedCountry: this.selectedCountry,
                    manage: this.options.manage
                });
            },
            'Register.States.Dropdown': function() {
                //console.log(this.loggedUserState)
                if(this.loggedUserState)
                this.selectedState =    this.loggedUserState;

                if(this.loggedUserCountry)
                this.selectedCountry =  this.loggedUserCountry;

                return new StatesView({
                    countries: this.countries,
                    selectedCountry: this.selectedCountry,
                    selectedState: this.selectedState,
                    manage: this.manage
                });
            }
    },  

    checkRegisterFields: function checkRegisterFields(){
      var allFilled = true;

      this.$('input[type="text"], input[type="email"], input[type="password"]').each(function () {
        var val = jQuery(this).val();
        if (!val || val.trim().length === 0) {
          allFilled = false;
          return false; // stop checking further
        }
      });

      // Check select fields only if inputs are fine
      if (allFilled) {
        this.$('select').each(function () {
          var val = jQuery(this).val();
          // Adjust this depending on your default option value
          if (!val || val === "" || val === "0" || val.toLowerCase().includes("select one")) {
            allFilled = false;
            return false;
          }
        });
      }

      var $btn = this.$('#in-modal-actual-register-submit');

      if (allFilled) {
        $btn.prop('disabled', false).addClass('completed');
      } else {
        $btn.prop('disabled', true).removeClass('completed');
      }

    },

    updateStates: function(e){
            var statesView = this.getChildViewInstance('Register.States.Dropdown');
            var selectedCountry= $(e.currentTarget).val();

            var self = this;
             
            var find_country = _.findWhere(self.countries, {
                    name: selectedCountry
                });

            //console.log(statesView)

            //this.selectedCountry = '';
            
            if(find_country)
            {
                //var available_states = find_country.states;
                statesView.options.selectedCountry = find_country.code;
                this.selectedCountry = find_country.code;
                statesView.render();

            }
            else{
                statesView.options.selectedCountry = '';
                this.selectedCountry = '';
                statesView.render();
            }
            //console.log(statesView)
        },      

    showHiddenSection: function(e){
        var $target = $(e.target)
        ,   currentAttr = $target.attr('id');

        /*$('.login-register-wrapper-login .section-body').addClass('hide');
        $('.login-register-wrapper-register .create-account-sec').removeClass('hide');

        $('.dont-have-account-sec').addClass('hide');
        $('.login-register-wrapper-login .login-to-acc-sec').addClass('open');

        $target.addClass('active');
        $('.create-account-sec').slideDown(500).addClass('open');

        $('.login-register-popup .popup-header').css('top','3%');*/
        //console.log(currentAttr)
        $('.login-register-popup .popup-header').css('top','3%');

        $('.create-account-sec').slideDown(500).addClass('open');
        $('.dont-have-account-sec').removeClass('open');

        $('.login-register-wrapper-login .login-to-acc-sec').addClass('open');
        $('.login-register-wrapper-login .section-body').slideUp(500).removeClass('open');
    },
	submitForm: function(e, model, props) {
        e.preventDefault();

        //console.log(Loggers)
        //const loggers = Loggers.getLogger();
       // const actionId = loggers.start('Customer Registration');

        const self = this;
        const data = (jQuery(e.target).closest('form')).serializeObject();
        //console.log(data)
        /*var customerInfo = {
            'firstname' : data.firstname,
            'lastname' : data.lastname,
            'password' : data.password,
            'password2' : data.password2,
            'company' : data.company,
            'email' : data.email
        }
        jQuery.ajax({
            url : 'https://www.aamedicalstore.com/sca-b2c-2023/services/popupRegister.ss',
            data : customerInfo,
            type: "POST",
            async: false,
            success: function(data, textStatus, jqXHR) {
              console.log(data);
             location.reload(true)
            },
            error: function (jqXHR, textStatus, errorThrown) {
             }
          });*/
        /*return this.cancelableTrigger('before:LoginRegister.register', data).then(function() {
            const promise = self.saveForm(e, model, props);
        });*/

        grecaptcha.ready(function() {
            grecaptcha.execute('6Ldm7swpAAAAAAvJ-a9wVCmWcuSIGrVogtSXESPD', {action: 'register'}).then(function(token) {
              var $form = self.$('form');
              $form.find('#in-modal-recaptcha_token').val(token);      

                    const promise = self.saveForm(e, model);
                    var $btn = $form.find('#in-modal-actual-register-submit');
                     $btn.prop('disabled', true).removeClass('completed');


                    if (promise) {
                        promise
                        .fail(function(jqXhr) {
                            //console.log(jqXhr)
                            var response = jqXhr.responseJSON
                            if(response.errorStatusCode === '400'){
                                //console.log(response.errorMessage);
                                var $alert_placeholder = self.$el.find('[data-type="register-alert-placeholder"]')
                                const global_view_message = new GlobalViewsMessageView({
                                    message: response.errorMessage,
                                    type: 'error',
                                    closable: false
                                });
                                 $alert_placeholder.html(
                                    global_view_message.render().$el.html()
                                );
                                 self.error = null;
                                //self.$el.find('[data-type="register-alert-placeholder"]').html(response.errorMessage)
                            }
                        })
                        .done(function(res) {
                            console.log(res);
                        })
                    }

            });
        });

        /*const promise = this.saveForm(e, model);
        if (promise) {
            promise
            .fail(function(jqXhr) {
                //console.log(jqXhr)
                var response = jqXhr.responseJSON
                if(response.errorStatusCode === '400'){
                    console.log(response.errorMessage);
                    var $alert_placeholder = self.$el.find('[data-type="register-alert-placeholder"]')
                    const global_view_message = new GlobalViewsMessageView({
                        message: response.errorMessage,
                        type: 'error',
                        closable: false
                    });
                     $alert_placeholder.html(
                        global_view_message.render().$el.html()
                    );
                     this.error = null;
                    //self.$el.find('[data-type="register-alert-placeholder"]').html(response.errorMessage)
                }
            })
            .done(function(res) {
                console.log(res);
            })
        }*/
    },
    beforeShowContent: function beforeShowContent() {
        const promise = jQuery.Deferred();
        const profileModel = ProfileModel.getInstance();

        if (profileModel.get('isLoggedIn') === 'T' && profileModel.get('isGuest') === 'F') {
            Backbone.history.navigate('', { trigger: true });

            promise.reject();
        } else {
            promise.resolve();
        }

        return promise;
    },

    // @method trackEvent tracks the 'create-account' event using the global Tracker instance
    // @param {Function} callback
    trackEvent: function(callback) {
        Tracker.getInstance().trackRegister({
            action: 'Checkout - User Interaction',
            category: 'Register',
            callback: callback
        });
    },

    // @method redirect redirects the user after successful account registration taking into account redirect (origin and origin_hash) parameters.
    // @param {Object} response the http response data object result of calling the account-register service.
    redirect: function(_context, response) {
        const self = this;

        return this.cancelableTrigger('after:LoginRegister.register').then(function() {

            console.log(response)
            if(response.code == 'OK')
            {
               //Snippet for GTM DataLayer       
                /*var userInfo = response.userData
                ,   loggedUserEmail = userInfo.email*/

                

                const gtm = GoogleTagManager;
                const eventName = 'identifyUser';
                 const eventData = {
                    event: eventName,
                    userEmail: response.userEmail
                 }
                 Tracker.trigger(eventName, eventData);
                 gtm.pushData(eventData);
                 //console.log(gtm.win)

                /*console.log(response.userEmail)
                var _etmc = [];
                _etmc.push(["setUserInfo", {"email": response.userEmail }]);
                _etmc.push(['trackPageView']);*/
             
                     
                 self.trackEvent(function() {
                    setTimeout(function(){
                        location.reload(true);
                    }, 1000);
                 });
             }
             else
             {
                $('.login-register-register-form-messages').html('<div class="global-views-message global-views-message-error alert" role="alert">Something went wrong, please try again later.</div>');
             }
        });
    }

		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{
			const url_options = typeof window !== 'undefined' ? Utils.parseUrlOptions(window.location.search) : {};

            var makeAnOfferConfgn = this.application.configuration.PDPMakeAnOffer
            ,   makeAnOfferConfig = makeAnOfferConfgn.config

            //console.log("isCheckoutDomain "+Utils.isCheckoutDomain())
            //console.log("isShoppingDomain "+Utils.isShoppingDomain())

			return {
				// @property {Boolean} showCompanyField
            showCompanyField: SC.ENVIRONMENT.siteSettings.registration.showcompanyfield === 'T',
            // @property {Boolean} isCompanyFieldRequire
            isCompanyFieldRequire:
                SC.ENVIRONMENT.siteSettings.registration.companyfieldmandatory === 'T',
            // @property {Boolean} isEmailSubscribeChecked
            isEmailSubscribeChecked:
                this.options.isEmailSubscribeChecked ||
                SC.ENVIRONMENT.siteSettings.defaultSubscriptionStatus,
            // @property {String} siteName
            siteName: SC.ENVIRONMENT.siteSettings.displayname,
            // @property {Boolean} showFormFieldsOnly
            showFormFieldsOnly: this.options.showFormFieldsOnly || false,
            // @property {Boolean} isRedirect
            isRedirect: !!(url_options.is !== 'checkout' && url_options.origin !== 'checkout'),
            // @property {Boolean} hasAutoFocus
            hasAutoFocus: url_options.is === 'register' && Utils.isDesktopDevice(),
			
            makeAnOfferConfig : makeAnOfferConfig
            };
		}
	});
});
